import { Button } from '@/components/Button';
import { Image } from '@/components/Image';
import { ImageCropper } from '@/components/ImageCropper';
import { Text } from '@/components/Text';
import { CreateEventForm } from '@/types/event';
import { FormikProps } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CreateEventCoverProps {
  setFieldValue: FormikProps<CreateEventForm>['setFieldValue'];
  values: FormikProps<CreateEventForm>['values'];
}

export const CreateEventCover = ({
  setFieldValue,
  values,
}: CreateEventCoverProps) => {
  const { t } = useTranslation();
  const [imageSrcForCrop, setImageSrcForCrop] = useState('');
  const [imageCropperIsOpen, setImageCropperIsOpen] = useState(false);
  const [coverPreview, setCoverPreview] = useState('');

  const handleUpdateCover = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.click();
    input.onchange = () => {
      const file = input.files?.[0];
      if (file) {
        setImageSrcForCrop(URL.createObjectURL(file));
        setImageCropperIsOpen(true);
      }
    };
  };

  const handleCropComplete = (croppedImage: File) => {
    setCoverPreview(URL.createObjectURL(croppedImage));
    const reader = new FileReader();
    reader.onload = () => {
      setFieldValue('cover', reader.result);
    };
    reader.readAsDataURL(croppedImage);
  };

  return (
    <div className="flex flex-col items-center justify-center md:items-start">
      <Text className="text-base font-medium text-sky-800">
        {t('createEvent:coverPhoto')}
      </Text>
      <div className="mt-4 flex w-full flex-col items-center justify-center">
        <Image
          className="aspect-video w-full rounded object-cover shadow-sm"
          src={coverPreview}
          alt="Cover"
        />
        <div className="mt-4 flex flex-col space-y-3 md:flex-row md:space-x-3 md:space-y-0">
          <Button onClick={handleUpdateCover}>
            {!values.cover
              ? t('createEvent:selectImage')
              : t('createEvent:updateImage')}
          </Button>
          {values.cover && (
            <Button
              className="bg-danger"
              onClick={() => {
                setFieldValue('cover', null);
                setCoverPreview('');
              }}
            >
              {t('createEvent:removeImage')}
            </Button>
          )}
        </div>
      </div>
      {imageCropperIsOpen && (
        <ImageCropper
          imageSrc={imageSrcForCrop}
          isOpen={imageCropperIsOpen}
          onClose={() => setImageCropperIsOpen(false)}
          ratio={16 / 9}
          onCropIsComplete={handleCropComplete}
        />
      )}
    </div>
  );
};
